var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-xs": "" } },
    [
      _c(
        "v-tabs",
        {
          attrs: { left: "" },
          model: {
            value: _vm.tabModel,
            callback: function($$v) {
              _vm.tabModel = $$v
            },
            expression: "tabModel"
          }
        },
        [
          _c("v-tab", { attrs: { href: "#tab-1" } }, [
            _vm._v("Parámetros del Sistema")
          ]),
          _vm.showTabParametrosCliente
            ? _c(
                "v-tab",
                { attrs: { href: "#tab-2", to: "/parametrosSistemaCliente" } },
                [_vm._v("Parámetros del Cliente")]
              )
            : _vm._e(),
          _c("v-spacer"),
          _vm.accionEditar.visible
            ? _c(
                "v-btn",
                {
                  staticClass: "btn-grabar",
                  staticStyle: { "margin-right": "20px" },
                  attrs: { left: "", depressed: "" },
                  on: {
                    click: function($event) {
                      _vm.dialogConfirmacion = true
                    }
                  }
                },
                [
                  _c("span", { staticStyle: { color: "white" } }, [
                    _vm._v("Guardar Cambios")
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    { attrs: { "d-flex": "", xs8: "", sm8: "", md8: "" } },
                    [_vm._v("Parámetro")]
                  ),
                  _c(
                    "v-flex",
                    { attrs: { "d-flex": "", xs2: "", sm2: "", md2: "" } },
                    [_vm._v("Valor")]
                  ),
                  _c(
                    "v-flex",
                    { attrs: { "d-flex": "", xs2: "", sm2: "", md2: "" } },
                    [_vm._v("Configurable por cliente")]
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs8: "",
                        sm8: "",
                        md8: ""
                      }
                    },
                    [_vm._v("Refrescar la visualización del mapa cada")]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.segundos,
                          "menu-props": "auto",
                          disabled: _vm.elementosDisabled,
                          label: "Segundos"
                        },
                        model: {
                          value: _vm.refrescoVisualizacionMapaSegundos,
                          callback: function($$v) {
                            _vm.refrescoVisualizacionMapaSegundos = $$v
                          },
                          expression: "refrescoVisualizacionMapaSegundos"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [_vm._v("Segundos")]
                  ),
                  _c(
                    "v-flex",
                    { attrs: { "d-flex": "", xs2: "", sm2: "", md2: "" } },
                    [
                      _c("v-switch", {
                        attrs: {
                          disabled: _vm.elementosDisabled,
                          color: "success"
                        },
                        model: {
                          value:
                            _vm.refrescarVisualizacionMapaConfigurableCliente,
                          callback: function($$v) {
                            _vm.refrescarVisualizacionMapaConfigurableCliente = $$v
                          },
                          expression:
                            "refrescarVisualizacionMapaConfigurableCliente"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs8: "",
                        sm8: "",
                        md8: ""
                      }
                    },
                    [_vm._v("Expiración de las variables de sesión")]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.horasSesion,
                          disabled: _vm.elementosDisabled,
                          "menu-props": "auto",
                          label: "Horas"
                        },
                        model: {
                          value: _vm.expiracionVariablesSesionHoras,
                          callback: function($$v) {
                            _vm.expiracionVariablesSesionHoras = $$v
                          },
                          expression: "expiracionVariablesSesionHoras"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [_vm._v("Horas")]
                  ),
                  _c(
                    "v-flex",
                    { attrs: { "d-flex": "", xs2: "", sm2: "", md2: "" } },
                    [
                      _c("v-switch", {
                        attrs: {
                          disabled: _vm.elementosDisabled,
                          color: "success"
                        },
                        model: {
                          value:
                            _vm.expiracionVariablesSesionConfigurableCliente,
                          callback: function($$v) {
                            _vm.expiracionVariablesSesionConfigurableCliente = $$v
                          },
                          expression:
                            "expiracionVariablesSesionConfigurableCliente"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs8: "",
                        sm8: "",
                        md8: ""
                      }
                    },
                    [_vm._v("Tiempo de eliminación de las notificaciones")]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          disabled: _vm.elementosDisabled,
                          "menu-props": "auto",
                          items: _vm.dias,
                          label: "Días"
                        },
                        model: {
                          value: _vm.eliminacionNotificacionesDias,
                          callback: function($$v) {
                            _vm.eliminacionNotificacionesDias = $$v
                          },
                          expression: "eliminacionNotificacionesDias"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [_vm._v("Días")]
                  ),
                  _c(
                    "v-flex",
                    { attrs: { "d-flex": "", xs2: "", sm2: "", md2: "" } },
                    [
                      _c("v-switch", {
                        attrs: {
                          disabled: _vm.elementosDisabled,
                          color: "success"
                        },
                        model: {
                          value:
                            _vm.eliminacionNotificacionesConfigurableCliente,
                          callback: function($$v) {
                            _vm.eliminacionNotificacionesConfigurableCliente = $$v
                          },
                          expression:
                            "eliminacionNotificacionesConfigurableCliente"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs8: "",
                        sm8: "",
                        md8: ""
                      }
                    },
                    [_vm._v("Tiempo de eliminación de las alertas")]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          disabled: _vm.elementosDisabled,
                          "menu-props": "auto",
                          items: _vm.horas,
                          label: "Horas"
                        },
                        model: {
                          value: _vm.eliminacionAlertasHoras,
                          callback: function($$v) {
                            _vm.eliminacionAlertasHoras = $$v
                          },
                          expression: "eliminacionAlertasHoras"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [_vm._v("Horas")]
                  ),
                  _c(
                    "v-flex",
                    { attrs: { "d-flex": "", xs2: "", sm2: "", md2: "" } },
                    [
                      _c("v-switch", {
                        attrs: {
                          disabled: _vm.elementosDisabled,
                          color: "success"
                        },
                        model: {
                          value: _vm.eliminacionAlertasConfigurableCliente,
                          callback: function($$v) {
                            _vm.eliminacionAlertasConfigurableCliente = $$v
                          },
                          expression: "eliminacionAlertasConfigurableCliente"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs8: "",
                        sm8: "",
                        md8: ""
                      }
                    },
                    [
                      _vm._v(
                        "Nº de reintentos fallidos del ingreso de la\n          contraseña"
                      )
                    ]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.intentos,
                          disabled: _vm.elementosDisabled,
                          "menu-props": "auto",
                          label: "Intentos"
                        },
                        model: {
                          value: _vm.reintentosFallidosAutenticacion,
                          callback: function($$v) {
                            _vm.reintentosFallidosAutenticacion = $$v
                          },
                          expression: "reintentosFallidosAutenticacion"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [_vm._v("Intentos")]
                  ),
                  _c("v-flex", {
                    attrs: { "d-flex": "", xs2: "", sm2: "", md2: "" }
                  })
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs8: "",
                        sm8: "",
                        md8: ""
                      }
                    },
                    [_vm._v("Tiempo en que los equipos no están transmitiendo")]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.unidadTiempoSeleccionada,
                          label: _vm.labelUnidadTiempoSeleccionada,
                          "menu-props": "auto",
                          disabled: _vm.elementosDisabled
                        },
                        model: {
                          value: _vm.actualizacionEstadoConexionGps,
                          callback: function($$v) {
                            _vm.actualizacionEstadoConexionGps = $$v
                          },
                          expression: "actualizacionEstadoConexionGps"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.unidadTiempo,
                          label: _vm.labelUnidadTiempoSeleccionada,
                          disabled: _vm.elementosDisabled
                        },
                        on: {
                          change: function($event) {
                            return _vm.tiempoCaducidad()
                          }
                        },
                        model: {
                          value: _vm.labelUnidadTiempoSeleccionada,
                          callback: function($$v) {
                            _vm.labelUnidadTiempoSeleccionada = $$v
                          },
                          expression: "labelUnidadTiempoSeleccionada"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { "d-flex": "", xs2: "", sm2: "", md2: "" } },
                    [
                      _c("v-switch", {
                        attrs: {
                          disabled: _vm.elementosDisabled,
                          color: "success"
                        },
                        model: {
                          value:
                            _vm.actualizacionEstadoConexionGpsConfigurableCliente,
                          callback: function($$v) {
                            _vm.actualizacionEstadoConexionGpsConfigurableCliente = $$v
                          },
                          expression:
                            "actualizacionEstadoConexionGpsConfigurableCliente"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        s8: "",
                        sm8: "",
                        md8: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n          Tiempo de caducidad del link de solicitud de cambio de\n          contraseña\n        "
                      )
                    ]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.horas,
                          label: "Horas",
                          "menu-props": "auto",
                          disabled: _vm.elementosDisabled
                        },
                        model: {
                          value: _vm.caducidadLinkSolicitudCambioContrasena,
                          callback: function($$v) {
                            _vm.caducidadLinkSolicitudCambioContrasena = $$v
                          },
                          expression: "caducidadLinkSolicitudCambioContrasena"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [_vm._v("Horas")]
                  ),
                  _c("v-flex", {
                    attrs: { "d-flex": "", xs2: "", sm2: "", md2: "" }
                  })
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        s8: "",
                        sm8: "",
                        md8: ""
                      }
                    },
                    [_vm._v("Tiempo de caducidad de contraseña")]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          type: "number",
                          max: "9999",
                          min: "1",
                          label: "Días",
                          disabled: _vm.elementosDisabled
                        },
                        on: {
                          keydown: _vm.estableceLimite,
                          blur: _vm.validaLimite
                        },
                        model: {
                          value: _vm.caducidadContrasenaDias,
                          callback: function($$v) {
                            _vm.caducidadContrasenaDias = $$v
                          },
                          expression: "caducidadContrasenaDias"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [_vm._v("Días")]
                  ),
                  _c("v-flex", {
                    attrs: { "d-flex": "", xs2: "", sm2: "", md2: "" }
                  })
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs8: "",
                        sm8: "",
                        md8: ""
                      }
                    },
                    [_vm._v("Tiempo de visualización en la campana")]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.horasCampana,
                          "menu-props": "auto",
                          disabled: _vm.elementosDisabled,
                          label: "Horas"
                        },
                        model: {
                          value: _vm.tiempoVisualizacionCampana,
                          callback: function($$v) {
                            _vm.tiempoVisualizacionCampana = $$v
                          },
                          expression: "tiempoVisualizacionCampana"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [_vm._v("Horas")]
                  ),
                  _c(
                    "v-flex",
                    { attrs: { "d-flex": "", xs2: "", sm2: "", md2: "" } },
                    [
                      _c("v-switch", {
                        attrs: {
                          disabled: _vm.elementosDisabled,
                          color: "success"
                        },
                        model: {
                          value:
                            _vm.tiempoVisualizacionCampanaConfigurableCliente,
                          callback: function($$v) {
                            _vm.tiempoVisualizacionCampanaConfigurableCliente = $$v
                          },
                          expression:
                            "tiempoVisualizacionCampanaConfigurableCliente"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs8: "",
                        sm8: "",
                        md8: ""
                      }
                    },
                    [_vm._v("Tiempo de visualización en el popup")]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.segundosPopUp,
                          "menu-props": "auto",
                          disabled: _vm.elementosDisabled,
                          label: "Segundos"
                        },
                        model: {
                          value: _vm.tiempoVisualizacionPopup,
                          callback: function($$v) {
                            _vm.tiempoVisualizacionPopup = $$v
                          },
                          expression: "tiempoVisualizacionPopup"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [_vm._v("Segundos")]
                  ),
                  _c(
                    "v-flex",
                    { attrs: { "d-flex": "", xs2: "", sm2: "", md2: "" } },
                    [
                      _c("v-switch", {
                        attrs: {
                          disabled: _vm.elementosDisabled,
                          color: "success"
                        },
                        model: {
                          value:
                            _vm.tiempoVisualizacionPopupConfigurableCliente,
                          callback: function($$v) {
                            _vm.tiempoVisualizacionPopupConfigurableCliente = $$v
                          },
                          expression:
                            "tiempoVisualizacionPopupConfigurableCliente"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-layout",
                [
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs8: "",
                        sm8: "",
                        md8: ""
                      }
                    },
                    [_vm._v("Tiempo Almacenamiento Informe Programado")]
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.diasInformes,
                          "menu-props": "auto",
                          disabled: _vm.elementosDisabled,
                          label: "Dias"
                        },
                        model: {
                          value: _vm.tiempAlmacenamientoInformeProgramado,
                          callback: function($$v) {
                            _vm.tiempAlmacenamientoInformeProgramado = $$v
                          },
                          expression: "tiempAlmacenamientoInformeProgramado"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      attrs: {
                        "align-center": "",
                        "d-flex": "",
                        xs1: "",
                        sm1: "",
                        md1: ""
                      }
                    },
                    [_vm._v("Días")]
                  )
                ],
                1
              ),
              _c("v-divider")
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacion,
          titulo: "Editar Parámetros del Sistema",
          mensaje: "¿Está seguro que desea guardar los cambios realizados?",
          textoBtnSi: _vm.$t("mensajes.crud.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.guardarCambios($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }